.popover {
  z-index: var(--z-dropdown);
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: min(420px, calc(100vw - 16px));
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  background: var(--color-bg);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-overlay);
  outline: none;
}

.popoverHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--color-border-subtle);
}

.popoverTitle {
  font-size: var(--type-heading-sm-size);
  line-height: var(--type-heading-sm-line);
  font-weight: var(--weight-semibold);
}

.popoverBody {
  padding: var(--space-4);
  overflow-y: auto;
}

.popoverBodyFlush {
  padding: 0;
  overflow-y: auto;
}

.menu {
  z-index: var(--z-dropdown);
  display: flex;
  flex-direction: column;
  min-width: 220px;
  max-width: min(360px, calc(100vw - 16px));
  padding: var(--space-1) 0;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  background: var(--color-bg);
  box-shadow: var(--shadow-overlay);
  outline: none;
}

.menuHeader {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--color-border-subtle);
  margin-bottom: var(--space-1);
}

.menuList {
  display: flex;
  flex-direction: column;
  outline: none;
}

.menuGroupLabel {
  padding: var(--space-2) var(--space-4) var(--space-1);
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  letter-spacing: var(--tracking-caption);
}

.menuItem {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 40px;
  padding: var(--space-2) var(--space-4);
  border: 0;
  background: transparent;
  color: var(--color-text-primary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  text-align: start;
  text-decoration: none;
  cursor: pointer;
  outline: none;
}

.menuItem:hover,
.menuItem:focus-visible,
.menuItem[data-active='true'] {
  background: var(--color-layer-hover);
  color: var(--color-text-primary);
}

.menuItem:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: -2px;
}

.menuItem svg {
  flex-shrink: 0;
  fill: var(--color-icon-secondary);
}

.menuItem[aria-disabled='true'] {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}

.menuItemDanger {
  color: var(--color-error);
}

.menuItemDanger svg {
  fill: var(--color-error-icon);
}

.menuItemDanger:hover,
.menuItemDanger[data-active='true'] {
  background: var(--color-error-bg);
  color: var(--color-error);
}

.menuItemLabel {
  flex: 1 1 auto;
  min-width: 0;
}

.menuCheck {
  margin-inline-start: auto;
  fill: var(--color-interactive) !important;
}

.menuDivider {
  height: 1px;
  margin: var(--space-1) 0;
  background: var(--color-border-subtle);
}

.backdrop {
  z-index: var(--z-modal);
  display: grid;
  place-items: center;
  padding: var(--space-4);
  background: var(--color-overlay-backdrop);
}

.modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 2 * var(--space-8));
  border-radius: var(--radius-lg);
  background: var(--color-bg);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-modal);
  outline: none;
}

.modalSm {
  max-width: 440px;
}

.modalMd {
  max-width: 600px;
}

.modalLg {
  max-width: 880px;
}

.modalHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-4) var(--space-3) var(--space-6);
}

.modalTitle {
  padding-top: var(--space-1);
  font-size: var(--type-heading-md-size);
  line-height: var(--type-heading-md-line);
  font-weight: var(--weight-semibold);
}

.modalDescription {
  margin-top: var(--space-1);
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.modalBody {
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-2) var(--space-6) var(--space-6);
  overflow-y: auto;
}

.modalFooter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6);
  border-top: 1px solid var(--color-border-subtle);
}

.drawerBackdrop {
  z-index: var(--z-modal);
  background: var(--color-overlay-backdrop);
}

.drawer {
  position: fixed;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: min(100vw, var(--drawer-width, 480px));
  background: var(--color-bg);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-modal);
  outline: none;
}

.drawerRight {
  right: 0;
}

.drawerLeft {
  left: 0;
}

.drawerHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  min-height: var(--size-header);
  padding: var(--space-3) var(--space-3) var(--space-3) var(--space-6);
  border-bottom: 1px solid var(--color-border-subtle);
}

.drawerTitle {
  padding-top: var(--space-1);
  font-size: var(--type-heading-md-size);
  line-height: var(--type-heading-md-line);
  font-weight: var(--weight-semibold);
}

.drawerBody {
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-6);
  overflow-y: auto;
}

.drawerBodyFlush {
  padding: 0;
}

.drawerFooter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6);
  border-top: 1px solid var(--color-border-subtle);
}

@media (max-width: 671px) {
  .backdrop {
    align-items: end;
    padding: 0;
  }

  .modal {
    max-width: none;
    max-height: calc(100vh - var(--space-8));
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  }

  .modalFooter > * {
    flex: 1 1 auto;
  }
}
